import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebaseConfig";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [pendingOrders, setPendingOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        // Fetch only pending orders
        const pendingQuery = query(collection(db, "orders"), where("status", "==", "pending"));
        const pendingSnapshot = await getDocs(pendingQuery);
        
        setPendingOrders(pendingSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        console.log("📌 Pending Orders fetched:", pendingOrders);
      } catch (error) {
        console.error("❌ Error fetching pending orders:", error);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div className="mt-10 p-6 bg-gray-900 rounded-lg text-center">
      <h2 className="text-2xl font-bold mb-4">Admin Dashboard</h2>

      <button
        onClick={() => navigate("/orders")}
        className="button"
      >
        View Orders
      </button>

      <button
        onClick={() => navigate("/order-history")}
        className="button"
      >
        View Order History
      </button>
    </div>
  );
};

export default AdminDashboard;

